module.exports = __webpack_public_path__ + "static/media/Army Message Clergy.6f4f23e0.jpg";